module.exports = __webpack_public_path__ + "img/dashboard.f0cd52d3.png";